<template lang="pug">
.card.rounded.mx-auto.mx-sm-2.mb-4(style='width: 18rem;')
    .bg.rounded-top
        img.img-fluid.card-img-top.py-3.px-5.rounded-circle( :src='cardContent.imgSrc')
    .card-body
        h5.card-title.text-primary.text-center {{ cardContent.name }}
        p.card-text.text-center
            template {{ cardContent.place }}
            br
            br
            strong {{ cardContent.teachs }}
            br
            br
            a(:href='telAsRef()') {{ cardContent.phone | pretty }}
</template>

<script>
export default {
    props: {
        cardContent: { type: Object, required: true }
    },
    methods: {
        telAsRef() {
            return `tel:521${this.cardContent.phone}`
        }
    },
    filters: {
        pretty: function (phone) {
            if (phone.startsWith('55') || phone.startsWith('81'))
                return phone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2 $3')
    
            return phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2 $3')
        }
    },
    beforeMount (){
        console.log (this.cardContent)
    }
}
</script>



// WEBPACK FOOTER //
// src/components/landing/instructors/InCard.vue